import { MODAL_ALERTA_HIDE, MODAL_ALERTA_SHOW, RESET_GLOBAL_CONTEXT } from "../ActionTypes";

import modalAlertaInitialState from "../initialStates/modalAlertaInitialState";

const modalAlerta = (state, { payload, type }) => {
  switch (type) {
    case MODAL_ALERTA_HIDE:
      return modalAlertaInitialState;
    case RESET_GLOBAL_CONTEXT:
      return modalAlertaInitialState;
    case MODAL_ALERTA_SHOW:
      return {
        modalAlerta: {
          show: true,
          data: payload,
        },
      };
    default:
      return state;
  }
};

export default modalAlerta;
